<template>
  <el-tabs v-model="activeName" type="border-card">
    <el-tab-pane
      :label="$lange == 'en' ? 'Work hour total' : '工时统计'"
      name="one"
    >
      <div class="daily-total">
        <div class="top flex-between">
          <p>
            <span>{{ $lange == "en" ? "Project" : "项目" }}:</span>
            <el-input
              size="mini"
              :placeholder="
                $lange == 'en' ? 'Please enter project name' : '请输入项目名称'
              "
              v-model="paramsData.projectName"
            ></el-input>
          </p>
          <p>
            <span>{{ $lange == "en" ? "Time" : "时间" }}:</span>
            <el-date-picker
              size="mini"
              v-model="dateValue"
              value-format="yyyy-MM-dd"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            ></el-date-picker>
          </p>
          <p>
            <el-button type="primary" size="mini" @click="doSearch">{{
              $lange == "en" ? "Search" : "搜索"
            }}</el-button>
            <el-button type="primary" size="mini" @click="doExport">{{
              $lange == "en" ? "Export" : "导出"
            }}</el-button>
            <el-button type="primary" size="mini" @click="openExport(1)"
              >按条件导出单元报工</el-button
            >
            <el-button type="primary" size="mini" @click="openExport(2)"
              >按条件导出工序报工</el-button
            >
          </p>
        </div>
        <div class="bottom">
          <cc-table :config="tableConfig" :params="paramsData2"></cc-table>
        </div>
      </div>

      <el-dialog
        :close-on-click-modal="false"
        title="导出"
        :visible.sync="dialog"
        width="440px"
        append-to-body
      >
        <div class="li">
          <el-input
            placeholder="请输入项目名称"
            style="width: 400px"
            v-model="exportData.workshopProjectName"
          ></el-input>
        </div>
        <div class="li">
          <el-input
            placeholder="请输入单元名称"
            style="width: 400px"
            v-model="exportData.name"
          ></el-input>
        </div>
        <div class="li">
          <!-- <el-cascader
            v-model="exportData.deptIdLike"
            clearable
            placeholder="请选择部门"
            :options="classList"
            change-on-select
            :show-all-levels="false"
            style="width: 400px"
            multiple
          >
          </el-cascader> -->

          <el-select
            v-model="exportData.deptIdLike"
            multiple
            clearable
            placeholder="请选择"
            style="width: 400px"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.fullname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="li">
          <el-date-picker
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :defaultTime="['00:00:00', '23:59:59']"
            v-model="exportData.time"
          >
          </el-date-picker>
        </div>
        <div class="tips" v-if="type==1">* 不输入任何搜索条件，则默认导出全部单元历史数据</div>
        <div class="tips" v-if="type==2">* 不输入任何搜索条件，则默认导出全部工序历史数据</div>

        <div class="button_wrap">
          <el-button @click="dialog = false">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
          <el-button type="primary" @click="editSubmitSomethingElse">{{
            $lange == "en" ? "Submit" : "确认导出"
          }}</el-button>
        </div>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import moment from "moment";
export default {
  name: "DailyTotal",
  data() {
    return {
      moment: "moment",
      activeName: "one",
      dateValue: [],
      paramsData: {
        starTime: "",
        endTime: "",
        projectName: "",
      },
      paramsData2: {
        starTime: "",
        endTime: "",
        projectName: "",
      },
      tableConfig: {
        api: "admin/fsb/workshop/project/projectStatistics",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "workshopProject.id",
            lable: "ID",
            minWidth: 160,
          },
          {
            prop: "workshopProject.name",
            lable: this.$lange == "en" ? "Project name" : "项目名称",
            type: "text",
            minWidth: 160,
          },
          {
            prop: "workshopProject.description",
            lable: this.$lange == "en" ? "Project description" : "项目描述",
            minWidth: 160,
          },
          {
            prop: "workshopUnitNum",
            lable: this.$lange == "en" ? "Unit number" : "单元数",
          },
          {
            prop: "workshopOrderNum",
            lable: this.$lange == "en" ? "Order number" : "订单数",
          },
          {
            prop: "workshopProcessNum",
            lable: this.language('workShop.阶段数'),
          },
            {
            prop: "workshopChildProcessNum",
            lable: this.$lange == "en" ? "Process number" : "工序数",
          },
          {
            prop: "estimatedWorkingHours",
            lable:  this.language("workShop.标准工时")
          },
          {
            prop: "actualWorkingHours",
            lable: this.$lange == "en" ? "Actual total hours" : "实际总工时",
          },
          // {
          //   prop: "expectedProduction",
          //   lable: this.$lange == "en" ? "Estimated output" : "预计产量",
          // },
          // {
          //   prop: "actualProduction",
          //   lable: this.$lange == "en" ? "Actual output" : "实际产量",
          // },
          {
            prop: "schedule",
            lable: this.$lange == "en" ? "Productiveness" : "效率",
          },
          {
            prop: "limitHoursSchedule",
            lable: this.$lange == "en" ? "Speed of progress" : "进度",
          },
          {
            prop: "workshopProject.startTime",
            lable: this.$lange == "en" ? "Start time" : "开始时间",
            render: (row) => {
              return moment(row.workshopProject.startTime).format("YYYY-MM-DD");
            },
            minWidth: 120,
          },
          {
            prop: "workshopProject.endTime",
            lable: this.$lange == "en" ? "End time" : "结束时间",
            render: (row) => {
              return moment(row.workshopProject.endTime).format("YYYY-MM-DD");
            },
            minWidth: 120,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            click: (row) => {
              this.$router.push({
                path: "/admin/workshop/total/des",
                query: {
                  id: row.workshopProject.id,
                },
              });
            },
          },
          {
            name: "",
            click: (row) => {},
          },
        ],
      },
      dialog: false,
      exportData: {},
      classList: [],
      type: 0,
    };
  },
  methods: {
    doSearch() {
      this.paramsData2 = { ...this.paramsData };
    },
    timeChange(res) {
      if (res) {
        this.paramsData.startTime = res[0];
        this.paramsData.endTime = res[1];
      } else {
        this.paramsData.startTime = "";
        this.paramsData.endTime = "";
      }
    },
    doExport() {
      let data = this.paramsData2;
      let text = "";
      for (const key in data) {
        if (data[key]) {
          text += "&" + key + "=" + data[key];
        }
      }
      window.open(
        "/admin/fsb/workshop/project/workStatisticsExport?appId=fosber" + text
      );
    },
    openExport(type) {
      this.type = type;
      this.dialog = true;
      this.exportData = {};
    },
    initClassList(data) {
      for (let i in data) {
        data[i].label = data[i].fullname;
        data[i].value = data[i].id;
        if (data[i].children.length > 0) {
          this.initClassList(data[i].children);
        } else {
          delete data[i].children;
        }
      }
    },
    getClassList() {
      this.ccRequest
        .do("admin/fsb/workshop/unit/getSubDeptList", { deptId: 49 }, "GET")
        .then((res) => {
          this.classList = res;
          this.initClassList(this.classList);
        });
    },
    editSubmitSomethingElse() {
      let text = "?appId=fosber";

      if (this.exportData.workshopProjectName) {
        text += "&workshopProjectName=" + this.exportData.workshopProjectName;
      }
      if (this.exportData.name) {
        text += "&name=" + this.exportData.name;
      }
      if (this.exportData.deptIdLike && this.exportData.deptIdLike.length>0) {
        text += "&deptIdLike=" + this.exportData.deptIdLike;
      }

      if (this.exportData.time && this.exportData.time.length > 0) {
        text += "&dailyStartTime=" + this.exportData.time[0];

        text += "&dailyEndTime=" + this.exportData.time[1];
      }
      if (this.type == 1) {
        window.open(
          "/admin/fsb/workshop/project/workStatisticsExportByCondition" + text
        );
      } else if (this.type == 2) {
        window.open(
          "/admin/fsb/workshop/project/workStatisticsExportProcessByCondition" +
            text
        );
      }
      this.dialog = false;
    },
  },
  mounted() {
    this.getClassList();
  },
};
</script>

<style scoped lang="scss">
.daily-total {
  .top {
    justify-content: flex-start;
    padding: 20px;
    border-bottom: 1px solid #f6f6f6;
    p {
      display: flex;
      margin-right: 20px;
      align-items: center;
      span {
        margin-right: 10px;
        width: 40px;
      }
    }
  }
  .bottom {
    padding: 20px;
  }
}
.li {
  width: 300px;
  margin-bottom: 20px;
}
.tips {
  color: #1ab394;
}
.button_wrap {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
